import type { ReactNode } from 'react';

export interface Coluna<T> {
  titulo: string;
  celula: (item: T) => ReactNode;
  /** Esconde a coluna em telas pequenas (o conteúdo principal continua visível). */
  secundaria?: boolean;
}

/**
 * Tabela acessível: legenda para leitores de tela, cabeçalhos com scope,
 * rolagem horizontal própria (a página nunca rola para o lado).
 */
export function Tabela<T>({
  legenda,
  colunas,
  itens,
  chave,
}: {
  legenda: string;
  colunas: Coluna<T>[];
  itens: T[];
  chave: (item: T) => string;
}) {
  return (
    <div className="overflow-x-auto rounded-xl border border-borda bg-superficie">
      <table className="w-full min-w-[640px] border-collapse text-left text-sm">
        <caption className="sr-only">{legenda}</caption>
        <thead className="bg-superficie-2 text-texto-suave">
          <tr>
            {colunas.map((c) => (
              <th
                key={c.titulo}
                scope="col"
                className={`px-4 py-3 font-semibold ${c.secundaria ? 'hidden md:table-cell' : ''}`}
              >
                {c.titulo}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {itens.map((item) => (
            <tr key={chave(item)} className="border-t border-borda align-top">
              {colunas.map((c) => (
                <td
                  key={c.titulo}
                  className={`px-4 py-3 text-texto ${c.secundaria ? 'hidden md:table-cell' : ''}`}
                >
                  {c.celula(item)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
